const isDesktopSingleSlide = (itemsInView, deviceType) => deviceType === "desktop" && itemsInView === 1;
const hasMultipleItems = (itemsInView) => itemsInView > 1;
const isNavigationDisabled = (canScroll, loop) => !canScroll && !loop;

export { hasMultipleItems, isDesktopSingleSlide, isNavigationDisabled };
